import React, { useMemo, useCallback } from 'react';
import { Button, Card } from 'react-bootstrap';
import Accordion from 'components/Accordion';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import useVariable from 'hooks/Meteorology/Fields/ModelPerformance/useVariable';
import usePeriodType from 'hooks/Meteorology/Fields/ModelPerformance/usePeriodType';
import useOptions from 'hooks/Meteorology/Fields/ModelPerformance/useOptions';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

export default function Variable() {
  const { variable, setVariable } = useVariable();
  const { periodType } = usePeriodType();
  const { variables } = useOptions();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('variable-accordion'), []);

  const isDisabled = !periodType;

  const setVariableAndClose = useCallback((value: string) => {
    setVariable(value);
    closeAccordion();
  }, [setVariable, closeAccordion]);

  return (
    <Accordion.Item eventKey="variable" id="variable-accordion">
      <Accordion.Header>
        <TitleSemiBold>Variável</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        {variables.map((v) => (
          <Card.Body key={v.id}>
            <Button
              variant="link"
              onClick={() => setVariableAndClose(v.id)}
              disabled={isDisabled}
              className={`w-100 btn-control-panel ${variable === v.id ? 'btn-control-panel-active' : ''} ${isDisabled ? 'disabled' : ''}`}
            >
              {v.label}
            </Button>
          </Card.Body>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
